import { weightProp, alignProp, trimProp, colorProp, highContrastProp } from '../helpers';
const sizes = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const weights = weightProp.values;
const headingPropDefs = {
    size: { type: 'enum', values: sizes, default: '6', responsive: true },
    weight: { ...weightProp, default: 'bold' },
    align: alignProp,
    trim: trimProp,
    color: colorProp,
    highContrast: highContrastProp,
};
export { headingPropDefs };
//# sourceMappingURL=heading.props.js.map